import { render } from "./customers.vue?vue&type=template&id=21154869&scoped=true"
import script from "./customers.vue?vue&type=script&lang=js"
export * from "./customers.vue?vue&type=script&lang=js"

import "./customers.vue?vue&type=style&index=0&id=21154869&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21154869"]])

export default __exports__